import { addDays, daysBetween } from './date';
import { Bar } from '../components/Bar';

export type ScaleMode = 'month' | 'week' | '2-weeks';

export function getScaleFromMode(mode: ScaleMode) {
  // month: 45; 2-weeks: 90; week: 220
  switch (mode) {
    case 'month':
      return 45;
    case 'week':
      return 220;
    case '2-weeks':
    default:
      return 90;
  }
}

export function getLayoutFromBar(
  bar: Bar,
  firstDate: Date
): { i: string; h: number; minH: number; maxH: number; x: number; w: number; y: number } {
  let x;
  let w;

  x = daysBetween(firstDate, bar.startDate);
  w = daysBetween(bar.startDate, bar.endDate) + 1;

  return { i: bar.id, h: 1, minH: 1, maxH: 1, x, w, y: bar.preferredY || 0 };
}

export function getDatesFromPos(firstDate: Date, x: number, w: number) {
  const startDate = addDays(firstDate, x);
  const endDate = addDays(startDate, w - 1);
  return { startDate, endDate };
}

export function getOffsetForDate(firstDate: Date, targetDate: Date) {
  return Math.round(daysBetween(firstDate, targetDate) * 1000) / 1000;
}

export const buildLayout = (data, firstDate) => {
  const layout = [] as any;
  data.forEach(bar => {
    layout.push(getLayoutFromBar(bar, firstDate));
  });
  return layout;
};

// export function getBarsAndLayoutFrom(
//   data: Bar[],
//   firstDate: Date
// ): { bars: { string: Bar }; layout: Position[] } {
//   const bars = buildMapFromArray(data);
//   const layout = buildLayout(data, firstDate) as Position[];
//   return { bars, layout };
// }
